import { HR_ROLE_ID, hasAdminAccess } from "../common/Functions";

export const LEAVE_MANAGEMENT_BASE_PATH = "/leave_approve";

export const LEAVE_MANAGEMENT_TABS = [
  { key: "requests", label: "Leave Requests" },
  { key: "balances", label: "Leave Balances", hrOrAdminOnly: true },
  { key: "ex-balances", label: "Ex-employee Balances", hrOrAdminOnly: true },
];

export const canManageLeaveBalances = (user) =>
  hasAdminAccess(user) || Number(user?.roleId) === HR_ROLE_ID;

export const getLeaveManagementTabPath = (tabKey) => {
  if (tabKey === "requests") return `${LEAVE_MANAGEMENT_BASE_PATH}/requests`;
  return `${LEAVE_MANAGEMENT_BASE_PATH}/${tabKey}`;
};

export const getLeaveManagementTabFromPath = (pathname, allowedTabKeys) => {
  const match = String(pathname || "").match(/\/leave_approve(?:\/([^/]+))?/);
  const tabKey = match?.[1] || "requests";
  if (allowedTabKeys.includes(tabKey)) return tabKey;
  return "requests";
};
